import { SearchInput, VStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import { RouteProp, useNavigation, useRoute } from '@react-navigation/native';
import { Box } from 'native-base';
import React, { useCallback, useState } from 'react';
import { useRecoilValue } from 'recoil';

import {
  AllSignedInRoutes,
  SignedInNavigationScreenNavigationProp,
} from '../../../../routes/types';
import {
  investmentStrategyFilterDiversifierAtom,
  investmentStrategyFilterPositiveAtom,
} from '../../../../store/home/conversion/atom';

import { FilterButton } from './components/FilterButton';
import { InvestmentStrategyCard } from './components/Positive/InvestmentStrategyCard';
import { InvestmentStrategyNavigationBar } from './components/Shared/InvestmentStrategyNavigationBar';
import { InvestmentStrategyTypeTabs } from './components/Shared/InvestmentStrategyTypeTabs';
import { investmentStrategyListTypes, InvestmentStrategyType } from './constants';
import { InvestmentStrategyTypes } from './types';

export const InvestmentStrategyMobile: React.FC<InvestmentStrategyTypes.Props> = () => {
  const [selectedViewOption, setSelectedViewOption] = useState<InvestmentStrategyType>('positive');
  const [searchTerm, setSearchTerm] = useState<string>('');
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();
  const { params } = useRoute<RouteProp<AllSignedInRoutes, 'HomeInvestmentStrategyMobile'>>();
  const { appliedFilters: appliedFiltersPositive } = useRecoilValue(
    investmentStrategyFilterPositiveAtom
  );
  const { appliedFilters: appliedFiltersDiversifier } = useRecoilValue(
    investmentStrategyFilterDiversifierAtom
  );

  let selectedFilterCount =
    selectedViewOption === 'positive'
      ? appliedFiltersPositive.length
      : appliedFiltersDiversifier.length;

  if (searchTerm) {
    selectedFilterCount = 0;
  }

  const handleFilter = useCallback(() => {
    if (selectedViewOption === 'positive') {
      navigate('HomeInvestmentStrategyFilterPositive');
    } else {
      navigate('HomeInvestmentStrategyFilterDiversifier');
    }
  }, [navigate, selectedViewOption]);

  const handleSearch = useCallback((value: string) => {
    setSearchTerm(value);
  }, []);

  const handleClear = useCallback(() => {
    setSearchTerm('');
  }, []);

  if (params?.isScreen) {
    const ContentComponent = investmentStrategyListTypes[selectedViewOption];

    return (
      <Box flex={1} paddingX={Spacing['inset.xs']} backgroundColor={Color['neutral.white']}>
        <VStack space={Spacing['stack.xxxs']} flex={1}>
          <InvestmentStrategyNavigationBar />
          <InvestmentStrategyTypeTabs
            selectedViewOption={selectedViewOption}
            onChange={setSelectedViewOption}
          />
          <SearchInput
            onSearch={handleSearch}
            onClear={handleClear}
            placeholder="Pesquise por cliente"
          />
          <Box alignItems="flex-end">
            <FilterButton onPress={handleFilter} appliedFilterCount={selectedFilterCount} />
          </Box>
          <ContentComponent isMobile searchTerm={searchTerm} />
        </VStack>
      </Box>
    );
  }

  return <InvestmentStrategyCard />;
};
